import { type AuthToken } from '@reliance/types/models/Auth';
import config from '../services/config';

export const outsideParty = (getToken: () => AuthToken) => ({
  photoUrl: (id: number): string => {
    return `${config.api.url}/visitor/photo/${id}?token=${
      getToken().accessToken
    }&r=${new Date()}`;
  },
});
